import SmartCarousel from "../../SmartCarousel";

export default function VenueSlider({ images, children, className = "", priority = false }) {
  return (
    <SmartCarousel
      images={images}
      className={className}
      priority={priority}
    >
      {children}
    </SmartCarousel>
  );
}
